<template>
    <div id="otp-input">
        <div class="input-container">
            <div class="input-box" :style="'width:4rem'">
                <input
                    :style="'width:4rem'"
                    id="accountInput"
                    type="text"
                    :maxlength="6"
                    :placeholder="$t('tips.Enter_OTP')"
                    v-model="code"
                    @input="onInput()"
                    @focus="focusEvent(true)"
                    @blur="focusEvent(false)"
                />
            </div>
            <div class="otp-btn" @click="sendCode()">{{ sendBtnVal }}</div>
        </div>
        <div class="tips" v-show="isErrMsg">
            <div class="input-error">{{ message }}</div>
        </div>
    </div>
</template>
<script>
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
import ServerManager from "../../interface/server";
export default {
    components: {},
    props: ["gamePanelShow"],
    data() {
        return {
            message: "",
            isErrMsg: false,
            userName: "",
            code: "",
            isFocus: false,
            showdel: true,
            isOk: false,
            maxLength: "",
            maxlength: 10,
            timerHanlder: null,
            delayTimes: 0,
            sendBtnVal: "OTP",
        };
    },
    mounted() {
        tools.on(eventConfig.CODE_ERROR, (err) => {
            this.showError(err);
        });
    },
    methods: {
        showError(error) {
            this.message = error;
            this.isErrMsg = true;
            this.isOk = false;
        },
        onInput() {
            this.code = this.code.trim();
            this.showdel = true;
            this.message = "";
            this.isErrMsg = false;
        },
        quickdel() {
            this.userName = "";
            this.code = "";
            this.showdel = true;
            this.message = "";
            this.isErrMsg = false;
        },

        focusEvent(e) {
            this.isFocus = e;
            if (this.isFocus) {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(-30%)";
            } else {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(0%)";
            }
            if (!this.isFocus) this.$emit("check-event");
            this.checkCode();
        },
        checkCode() {
            if (this.code == "") {
                this.message = this.$t("tips.OTP_is_required");
                this.isErrMsg = true;

                this.isOk = false;
                return;
            }

            this.isOk = true;
            // return;
        },
        startTime() {
            if (!this.timerHanlder) {
                clearInterval(this.timerHanlder);
            }
            this.delayTimes = 60;
            this.timerHanlder = setInterval(() => {
                this.delayTimes--;
                this.sendBtnVal = "(" + this.delayTimes + "s" + ")";
                if (this.delayTimes < 0) {
                    this.sendBtnVal = this.$t("common.OTP");
                    this.isf;
                    this.isUse = false;
                    clearInterval(this.timerHanlder);
                    this.timerHanlder = null;
                }
            }, 1000);
        },
        sendCode() {
            if (this.delayTimes > 0) {
                return;
            }

            this.$emit("on-sendcode");
        },
        focusInput(id) {
            document.getElementById(id).focus();
        },
    },
    watch: {},
    destroyed() {
        tools.off(eventConfig.CODE_ERROR);
    },
};
</script>
<style >
@import "../../assets/css/login.css";
#otp-input {
    position: relative;
    width: 580px;
    height: 82px;
}
.otp-btn {
    position: absolute;
    right: 4px;
    top: 2px;
    width: 140px;
    height: 58px;
    background: #f82838;
    border-radius: 29px;

    font-size: 30px;
    font-weight: bold;
    color: #dcdcdc;
    line-height: 58px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/input_user_otp.vue